// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ArtifactActions-primaryButton-1FRKdH","actions":"ArtifactActions-actions-3yhyC6","actionLink":"ArtifactActions-actionLink-1TG1WF"};